import { useCallback, useEffect, useState } from 'react';
import { throttle } from 'src/utils/helpers.utils';
import { useIsMounted } from 'src/hooks/useIsMounted';
import { isMobileOnly } from 'react-device-detect';

export const useCalculateExploreItemHeight = ({ selector, initialHeight }:{selector: string, initialHeight: string}) => {
    const isMounted = useIsMounted();
    const [itemHeight, setItemHeight] = useState(initialHeight);
    const calculateItemHeight = useCallback(throttle(() => {
        if(isMobileOnly) {
            return;
        }
        const exploreItem = document.querySelector(`[${selector}]`);
        isMounted(() => {
            const height = exploreItem?.clientHeight ? `${exploreItem?.clientHeight}px` : initialHeight;
            setItemHeight(height);
        });
    }), []);

    useEffect(() => {
        isMobileOnly && setItemHeight('auto');
    }, []);

    return {
        calculateItemHeight,
        itemHeight
    };
};

